import { successType } from "redux-api-status";
import initialState from "./initialState";
import * as types from "../actions/actionTypes";

export default function candidateReducer(
  state = initialState.candidate,
  action
) {
  switch (action.type) {
    case types.UPDATE_CANDIDATE_PICTURE_SUCCESS:
      return {
        ...state,
        Profile: action.payload.data,
      };
    case successType(types.CREATE_CANDIDATE_DOCUMENT):
      return {
        ...state,
      };

    case successType(types.LOAD_CANDIDATE):
      const Candidate = action.payload;
      return {
        ...state,
        Profile: Candidate,
        ComplianceStatus: Candidate.candidatesComplianceStatus,
        Documents: Candidate.documents,
        DisqualificationDeclarations: Candidate.disqualificationDeclarations,
        SafeguardingDeclarations: Candidate.safeguardingDeclarations,
        HealthDeclarations: Candidate.healthDeclarations,
        PermittedJobRoles: Candidate.candidatePermittedJobRoles,
        OverseasPoliceChecks: Candidate.overseasPoliceChecks,
        Qualifications: Candidate.qualifications,
        WorkHistory: Candidate.workHistory,
        DBSChecks: Candidate.dbsChecks,
        YotiChecks: Candidate.yotiChecks,
        RTWChecks: Candidate.rtwChecks,
        References: Candidate.candidateReferences,
        JobRolesFullList: [],
        History: [],
      };
    case successType(types.LOAD_CANDIDATE_DOCUMENTS):
      return {
        ...state,
        Documents: action.payload.data,
      };

    case successType(types.LOAD_CANDIDATE_HISTORY):
      return {
        ...state,
        History: action.payload.data,
      };
    case successType(types.LOAD_CANDIDATE_CLIENTPREFERENCES):
      return {
        ...state,
        ClientPreferences: action.payload.data,
      };
    case successType(types.LOAD_CANDIDATE_JOBROLESFULLLIST):
      return {
        ...state,
        JobRolesFullList: action.payload.data,
      };

    case successType(types.LOAD_CANDIDATE_COMPLIANCESTATUS):
      return {
        ...state,
        ComplianceStatus: action.payload.data,
      };

    case successType(types.LOAD_CANDIDATE_CHAT):
      return {
        ...state,
        Chat: action.payload.data.reverse(),
      };
    case successType(types.LOAD_OVERSEASPOLICECHECKS):
      return {
        ...state,
        OverseasPoliceChecks: action.payload.data,
      };
    case successType(types.LOAD_QUALIFICATIONS):
      return {
        ...state,
        Qualifications: action.payload.data,
      };
    case successType(types.LOAD_WORKHISTORY):
      return {
        ...state,
        WorkHistory: action.payload.data,
      };
    case successType(types.LOAD_REFERENCES):
      return {
        ...state,
        References: action.payload.data,
      };
    case successType(types.LOAD_RTWCHECKS):
      return {
        ...state,
        RTWChecks: action.payload.data,
      };
    case successType(types.LOAD_DBSCHECKS):
      return {
        ...state,
        DBSChecks: action.payload.data,
      };
    case successType(types.LOAD_HEALTHDECLARATIONS):
      return {
        ...state,
        HealthDeclarations: action.payload.data,
      };
    case successType(types.LOAD_CANDIDATE_AVAILABILITY):
      return {
        ...state,
        Diary: action.payload.data,
      };
    case successType(types.LOAD_CANDIDATE_BOOKINGDAYS):
      return {
        ...state,
        BookingDays: action.payload.data,
      };
    default:
      return state;
  }
}
